import { createAsyncThunk } from '@reduxjs/toolkit';

import { getInitialData } from '../components/Profile/controller-utils';
import type { ThunkApiConfig } from '../types';
import type { RootState } from './root-reducer';

export const initialStateRefetch = createAsyncThunk<
  RootState,
  void,
  ThunkApiConfig
>(
  'root/initialStateRefetch',
  async (_, { extra: { flowAPI, widgetPluginService, warmupDataService } }) => {
    const { initialState } = await getInitialData(
      flowAPI,
      widgetPluginService,
      warmupDataService,
    );
    return initialState;
  },
);
